import React from 'react'
import {connect} from 'react-redux'
import {Redirect} from 'react-router-dom'
import RefundsFilter from './containers/RefundsFilter'
import RefundsList from './containers/RefundsList'

const mapStateToProps = state => {  
  return {    
    isLogged: state.user.isLogged,        
  }
}

class Refunds extends React.Component{
  
  render() {
    if (!this.props.isLogged)
      return <Redirect to='/'/>;
      
    return this.renderReport()
  }
  renderReport(){
    return (
      <div>        
        <RefundsFilter/>
        <RefundsList />
      </div>
    )
  }
}
export default connect(
  mapStateToProps,
  //mapDispatchToProps
)(Refunds)


// WEBPACK FOOTER //
// ./src/Refunds.js